import { memo } from 'react';
import { NodeProps } from '@xyflow/react';

import { getVariableDefinitions } from '@/explore/utils';
import { useExplorationContext } from '@/explore/exploration/exploration-context';
import { useExplorationUIContext } from '@/explore/exploration/exploration-ui-context';
import { ExplorationCell } from '@/explore/exploration/exploration-cell';
import { isChatCell, isConversationCell, isConversationPart } from '@/core/cell';
import { ConversationLink } from '@/explore/conversation/conversation-link';

import canvasStyles from './canvas.module.scss';

const CanvasCardNode = ({ zIndex, data, id: conversationId }: NodeProps) => {
  const { exploration, parameters, getCellById, isConversationSubject } = useExplorationContext();
  const { selectedCell, openEditor } = useExplorationUIContext();
  const conversationCell = exploration.view.cells.find(
    (cell) => isConversationCell(cell) && cell.conversationId === conversationId,
  );
  const cellIds = data.cellIds as string[];
  const cells = cellIds.map(getCellById).filter((cell) => cell !== undefined);
  const legacyConversation = cells.some(isChatCell);

  if ((!conversationCell && !legacyConversation) || !cells.length) {
    return null;
  }

  return (
    <div className={canvasStyles.canvasGroup}>
      {cells.map((cell) => {
        const cellIsConversationSubject = isConversationSubject(cell);

        const conversationSubject = cellIsConversationSubject
          ? cell
          : isConversationCell(cell)
            ? exploration.view.cells.find(
                (c) =>
                  isConversationPart(c) &&
                  !isConversationCell(c) &&
                  c.conversationId === cell.conversationId,
              )
            : undefined;

        return (
          <div className={canvasStyles.cellWrapper} key={cell.id}>
            <ExplorationCell
              key={cell.id}
              cell={cell}
              variables={getVariableDefinitions(exploration)}
              isCollapsible={false}
              isResizable={false}
              selected={selectedCell?.id === cell.id}
              parameters={parameters}
              canvasView
              onSelectCell={() => openEditor(cell.id)}
              style={{ zIndex }}
            />

            {cellIsConversationSubject &&
              conversationSubject !== undefined &&
              !legacyConversation && <ConversationLink conversationSubjectIndex={0} row={[cell]} />}
          </div>
        );
      })}
    </div>
  );
};

export default memo(CanvasCardNode);
